import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "../Pages/auth/login/Login";
import Dashboard from "../Pages/Dashboard/Dashboard";
import UsersList from "../Pages/Users/UsersList/UsersList";
import List from "../Pages/Users/List/List";
// import User from "../Pages/Users/index";
import Home from "../Pages/Home/Home";
import VendorForm from "../Pages/Users/VendorForm/VendorForm";
import EditUser from "../Pages/Users/EditUser/EditUser";
import CreateUser from "../Pages/Users/CreateUser/CreateUser";
import CreateVendor from "../Pages/Users/CreateVendor/CreateVendor";
import EditVendor from "../Pages/Users/EditVendor/EditVendor";
import ReportsMain from "../Pages/Reports";
import ReportDetail from "../Pages/Reports/ReportDetail";
import UserDetails from "../Pages/Details/UserDetails/UserDetails";
import VendorDetails from "../Pages/Details/VendorDetails/VendorDetails";
import Usertype from "../Pages/UserType/Usertype";
import ChangePassword from "../components/change-password/ChangePassword";
import InvoicePage from "../Pages/Invoice/index";

const AppRoures = () => {
  let isAuthenticatedData = JSON.parse(localStorage.getItem("accessToken"));
  const [IsAuthenticated, setIsAuthenticated] = useState(
    isAuthenticatedData ? isAuthenticatedData : null
  );
  return (
    <Router>
      <Routes>
        {IsAuthenticated ? (
          <>
            <Route
              path="/"
              element={
                <Home
                  IsAuthenticated={IsAuthenticated}
                  setIsAuthenticated={setIsAuthenticated}
                />
              }
            >
              <Route
                path="/cms/dashboard"
                element={<Dashboard loginDetails={isAuthenticatedData} />}
              />
              {/* <Route path="/cms/users-list" element={<UsersList />} /> */}
              <Route path="/cms/users-list" element={<List />} />
              <Route path="/cms/add-user" element={<CreateUser />} />
              <Route
                path="/cms/edit-user/:id"
                element={<EditUser loginDetails={isAuthenticatedData} />}
              />
              <Route path="/cms/add-vendor" element={<CreateVendor />} />
              <Route path="/cms/edit-vendor/:id" element={<EditVendor />} />
              <Route path="/cms/reports" element={<ReportsMain />} />
              <Route path="/cms/userdetails/:id" element={<UserDetails />} />
              <Route
                path="/cms/vendordetails/:id"
                element={<VendorDetails />}
              />
              <Route
                path="/cms/reports-detail/:date"
                element={<ReportDetail />}
              />
              <Route path="/cms/userType" element={<Usertype />} />
              <Route
                path="/cms/reset-password/:id"
                element={<ChangePassword />}
              />
              <Route path="/cms/invoice" element={<InvoicePage />} />
              <Route path="/" element={<Navigate to="/cms/dashboard" />} />
              <Route path="*" element={<Navigate to="/cms/dashboard" />} />
            </Route>
          </>
        ) : (
          <>
            <Route
              path="/cms/login"
              element={<Login setIsAuthenticated={setIsAuthenticated} />}
            />
            <Route path="*" element={<Navigate to="/cms/login" replace />} />
          </>
        )}
      </Routes>
    </Router>
  );
};

export default AppRoures;
